module.exports = __webpack_public_path__ + "img/百香果9.a2b0159d.png";